// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector} from 'reselect';
import { WorkshopInformation } from '../../../types/Model';
import { WorkshopInformationState } from '../../reducers/workshopDataReducer';

import { RootState } from '../../rootReducer';

export const workshopsRaw = (state: RootState):WorkshopInformationState => state.workshopDataReducer

/**
 * when select specific workshop, return the content
 */
export const makeWorkshopByIdSelector = (id: number): Selector<RootState, WorkshopInformation> =>
  createSelector(
    workshopsRaw,
    (workshopsReducer) => workshopsReducer.workshops[id] || {} as WorkshopInformation
  );

export const makeIsFetchingWorkshop = (): Selector<RootState, boolean> => {
  return createSelector(
    workshopsRaw,
    (workshopsReducer) => workshopsReducer.isInformationFetching
  );
};

export const makeError = (): Selector<RootState, Error | undefined> => {
  return createSelector(
    workshopsRaw,
    (workshopsReducer) => workshopsReducer.error
  );
};
